import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import { useParams } from "react-router-dom";
import { formatDate } from "../../../utils/commonFunctions";
import { DatePicker } from "antd";
import moment from "moment";

function DateTime({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) {
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [defValue, setDefValue] = useState("");

  const [element, setElement] = useState({
    type: "datetime",
    properties: {
      label: "Date Time Element",
      required: true,
      value: "",
    },
  });

  const [readOnly, setReadOnly] = useState(false);

  console.log(element);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    setElement((prev) => ({...prev,...data}));
    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => ({...prev,...obj}));
    // }

    if (
      data?.disableField === true &&
      data?.properties?.value &&
      data?.properties?.value?.length !== 0 &&
      localStorage.getItem("user.role") !== "admin"
    ) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [data, isChild]);

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  const savedDate = element.properties.value || null;

  return (
    <div className="form-group col-md-12 form-builder-element mb-3">
      <label htmlFor="">
        {element.properties.label}
        <If test={element.properties.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>
      <div
        className="form-view"
        label={element?.properties?.label}
        data={JSON.stringify(element)}
      >
        <DatePicker
          style={{ width: "100%" }}
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          value={savedDate ? moment(savedDate, "YYYY-MM-DD HH:mm:ss", true) : null}
          className={`${foundError ? "border border-danger" : ""}`}
          placeholder={element.properties.label}
          disabled={
            readOnly ||
            approve ||
            !element.editable ||
            (defValue && hasChiledReadOnly) ||
            ocrDisabled
          }
          onChange={(value, dateString) => {
            if (isInputFieldTouched) {
              isInputFieldTouched();
            }
            setElement((prev) => {
              return {
                ...prev,
                properties: {
                  ...prev.properties,
                  value: dateString,
                },
              };
            });
          }}
          disabledDate={(current) => {
            if (!current) return false;
            if (element.past && element.future) {
              return !current.isSame(moment(), "day");
            }
            if (element.past) {
              return current < moment().startOf("day");
            }
            if (element.future) {
              return current > moment().endOf("day");
            }
            return false;
          }}
        />
      </div>
      {foundError && <p className="text-danger">{foundError?.value}</p>}
    </div>
  );
}

export default DateTime;
